import script from "./PageLogin.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageLogin.vue?vue&type=script&setup=true&lang=ts"

import "./PageLogin.vue?vue&type=style&index=0&id=8fc8e9ae&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fc8e9ae"]])

export default __exports__